module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAABPElEQVQokX3SMUtdQRAF4O9dn0QLbS0ECfhiHRRMCAjRJrHTSisRbfwHIry8ELHKL5CAjUUKK0HQCGkSFBFXEIkgCCJGOy0VJAEtdoWn3uuBhWXnzM6cmVMKIUAbvmII/7CCKs5FtGEWH3GLVdRwkaEVvxK5E69wgm28RHu6X+E9BnCN32gphRA+owOTHqKGXtxgH18exRdwWgoh7GMC4RHhBY5Sy13po3q8xmIZFRx4iht8w/+cZDhEpSwOrZxDgPmCd2jCbYZNDBeQLtLJwwh+lvEJazjGxjMV6zGIOfRn2MUYljCjWA40i36ZFz3zJ0uBH3gj7jmgJyf5LfbElXeL0mV1hL/4kCqsY6ouNo5lTGMUl/eBvHa/Y0ecS6Pouir6RF88QJHeoyRnCw14J9r7CZ4b2FlqvVSUDHcEj0rwwfStlQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bicon04.png
// module id = 210
// module chunks = 3